import React, { useMemo } from "react";
import { isEqual } from "lodash";

import { Order } from "../../../../../../../services";
import { useTypedSelector } from "../../../../../../../redux/store";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const PhoneCellContent: React.FC<PhoneCellContent.Props> = ({ item }) => {
	const orderSettings = useTypedSelector((state) => state.settings.order);

	const { content, backgroundColor, textColor, highlighted } = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const isOrderSettingsEqual = !!(
			item?.cellsForTableSettings?.orderSettings &&
			isEqual(item.cellsForTableSettings.orderSettings, orderSettings)
		);

		const preparedCell = item?.cellsForTable?.[ColumnId.Phone];

		if (isCellsReady && isOrderSettingsEqual && preparedCell) {
			return preparedCell;
		}

		return cellProcessing(item, orderSettings);
	}, [item, orderSettings]);

	return (
		<CellContentRoot
			alignItems="center"
			backgroundColor={backgroundColor}
			textColor={textColor}
			highlighted={highlighted}
			h="100%"
			w="100%"
		>
			{content}
		</CellContentRoot>
	);
};

declare namespace PhoneCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default PhoneCellContent;
